import { useQuery } from '@tanstack/react-query'

import { BROKE_FLEX_MESSAGE_KEYS } from '../../keys'
import { BrokeFlexMessageService } from '../services/BrokeFlexMessageService'
import type { BrokeFlexAnalyticsListResponse } from '../../types'

export default function useQueryGetBrokeFlexAnalytics() {
	return useQuery<BrokeFlexAnalyticsListResponse>({
		queryKey: BROKE_FLEX_MESSAGE_KEYS.ANALYTICS,
		queryFn: () => BrokeFlexMessageService.getAllAnalytics(),
	})
}
